import { authHeader } from '../../../services/auth-header'
import axiosAPI from '../../../../axios-API'

async function getAll ({ commit }) {
  commit('GET_ALL_REQUEST')

  const config = {
    headers: authHeader(),
  }
  return await axiosAPI.get('/v2/manage/s/u', config).then(item => item.data.result)
    .then(
      users => commit('GET_ALL_SUCCESS', users),
      error => commit('GET_ALL_FAILURE', error),
    )
}

function changePassword ({ commit }, [newPassword, id]) {
  const body = {
      password: newPassword,
  }
  axiosAPI.put(`/v2/manage/s/u/${id}/recover-password`, body)
}

/**
 * Generates a random password of 30 characters including
 * uppercase, lowercase, numbers, and special characters.
 */
function generateRandomPassword ({ commit }) {
  const length = 30
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*+?-='
  let password = ''
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length)
    password += charset[randomIndex]
  }
  return password
}

async function findUser ({ commit }, { name, username }) {
  const query = name ? `name=${name}` : `username=${username}`

  try {
    const res = await axiosAPI.get(`/v2/manage/s/u?${query}`)
    const users = res.data.results || []

    commit('KEEP_FOUND_USER', users)
  } catch (error) {
    commit('KEEP_FOUND_USER', [])
    console.error('Erro ao buscar usuário:', error)
  }
}

let reqLOCK = false
async function getUser ({ commit }, id) {
  if (reqLOCK) return
  reqLOCK = true

  try {
    return await axiosAPI.get(`/v2/manage/s/u/${id}`).then((res) => {
      return res.data.result
    })
  } finally {
    reqLOCK = false
  }
}

function deleteUser ({ commit }, id) {
  return axiosAPI.delete(`/v2/manage/s/u/${id}`)
}

function updateUser ({ commit }, user) {
  return axiosAPI.put(`/v2/manage/s/u/${user._id}`, user)
}

function createUser ({ commit }, user) {
  return axiosAPI.post('/v2/manage/s/u/', user)
}

export default {
  getUser,
  getAll,
  deleteUser,
  changePassword,
  generateRandomPassword,
  findUser,
  updateUser,
  createUser,
}
